import { Injectable } from "@angular/core";
import { DoctorOption, ValueTextPair, ValueTextPairNumberValue } from "src/app/shared/models/value-text-pair";
import { Position } from "src/app/system/position/models/position";
import { User } from "src/app/system/user/models/user";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { PageData2 } from "src/app/shared/models/page-data";
import { CustomResult } from "src/app/shared/models/custom-result";

export class FullUser {
  name: string;
  ename: string;
  account: string
  roles: ValueTextPair[];
  positions: ValueTextPair[];
  clinics: ValueTextPair[];
  mainDept: string;
  needChangePwd: boolean;
  prefs: UserPreference;
  lastChangePasswordTime?:Date;
  twoFactorValue?:TwoFactorValue;
  email:string;
  phone:string;
}
export class UserPreference {
  UserId: number;
  HistCC: string[];
  HistPE: string[];
  HistDx: string[];
  HistRx: string[];
  HistEx: string[];
  Menu: string[];
  HistDxFreq: 'Week' | 'Month' | 'Season';
  HistDxSrc: 'Self' | 'Clinic';
  HistRxFreq: 'Week' | 'Month' | 'Season' | 'Dx';
  HistRxSrc: 'Self' | 'Clinic';
  HistCCPEFreq: 'Week' | 'Month' | 'Season' | 'Dx';
  HistCCPESrc: 'Self' | 'Clinic';
  HistCCPECode: boolean;
  HistPageSize: number;
  RecentFromDate: Date;
  FontGreat: boolean;
  HistPadHide: boolean;
  CustomHelpPadTab: string;
  HistQueryMode:'simple'|'detail';
}
export enum TwoFactorValue{
  None=0,
  SMS=1,
  EMAIL=2
}
export var TwoFactorDesc = [ 
  {value:TwoFactorValue.None,text:'無' },
  {value:TwoFactorValue.SMS,text:'簡訊' },
  {value:TwoFactorValue.EMAIL,text:'電子郵件' },
]
export interface UserSecurity{
  LastChangePasswordTime:string,
  TwoFactorValue: TwoFactorValue,
  Email:string,
  Phone:string
}

@Injectable({ providedIn: 'root' })
export class UserApi {
  apiService: WebApiService;
  /**
   *
   */
  constructor(private apiClient: WebApiClient) {
    this.apiService = this.apiClient.createHisService('system/user');
    this.apiService.enableLoader = false;
  }
  async get(id: number): Promise<User> {
    return this.apiService.get('get/' + id).toPromise();
  }
  async getOptions(): Promise<CustomResult> {
    return this.apiService.get('GetOptions').toPromise();
  }
  async getClinicAllUserOption(): Promise<UserListDto[]> {
    return this.apiService.get('GetClinicAllUserOption').toPromise<UserListDto[]>();
  }
  async hasEnabledFamilyCareUser(): Promise<boolean> {
    return this.apiService.get('HasEnabledFamilyCareUser').toPromise<boolean>();
  }
  async getFullUser(id: any): Promise<FullUser> {
    return this.apiService.get('GetFullUser?id=' + id).toPromise<FullUser>();
  }
  async changePwd(oldPwd: string, newPwd: string): Promise<void> {
    return this.apiService.put('changepassword?' + 'oldpassword=' + oldPwd + '&newpassword=' + newPwd, {}).toPromise()
  }
  async UpdatePrefs(model: UserPreference): Promise<void> {
    return this.apiService.post('UpdatePrefs', model).toPromise()
  }
  async getPositions(id: number): Promise<void> {
    return this.apiService.get('get/' + id).toPromise()
  }
  async getAll(name: string, account: string, cid: string, positionId: number[]): Promise<PageData2<UserListDto>> {
    return this.apiService.get('GetAll', {
      name, account, cid, positionId: positionId.join(',')
    }).toPromise()
  }
  async getCompanyAll(q?: UserListQuery): Promise<PageData2<UserListDto>> {
    return this.apiService.get('GetCompanyAll', q).toPromise()
  }
  async getCompanyUserPositions(): Promise<ValueTextPair[]> {
    return this.apiService.get('GetCompanyUserPositions').toPromise()
  }
  async login() {
    await this.apiService.post('Login', null).toPromise();
  }
  async GetDoctors(): Promise<DoctorOption[]> {
    return this.apiService.get('GetDoctors').toPromise()
  }
  async GetPharmarcist(): Promise<ValueTextPair[]> {
    return this.apiService.get('GetPharmarcist').toPromise()
  }
  async GetDoctorAndNurse(isShowNurse: boolean, isShowLeave: boolean, date = null,isShowingDisabled:boolean): Promise<ValueTextPairNumberValue[]> {
    return this.apiService.get('GetDoctorAndNurse?' + 'isShowNurse=' + isShowNurse + '&isShowLeave=' + isShowLeave + '&date=' + date+'&isShowingDisabled=' +isShowingDisabled).toPromise()
  }
  async GetDoctorList():Promise<ValueTextPairNumberValue[]>{
    return this.apiService.get('GetDoctorList').toPromise()
  }
  async updateSecurity(data:UserSecurity):Promise<boolean>{
    return this.apiService.post('updateSecurity',data).toPromise()
  }
  async Test2FV(twoFactorType: TwoFactorValue, target:string):Promise<string>{
    return this.apiService.post('Test2FV',{
      Target:target,
      Type:twoFactorType
    }).toPromise()
  }
}
export declare type UserListQuery = {
  account: string,
  name: string,
  cid: string,
  positionId: string;
  pageSkip: number;
  pageSize: number;
}
export type UserListDto = {
  Id: number,
  Account: string,
  Name: string,
  IsDoctor: number,
  Positions: string,
  IsEnabled: boolean,
}
